(function () {
  angular.module("akitabox.workOrder.create").run(states);

  /* @ngInject */
  function states(Router, models) {
    var queryParams = [
      models.BUILDING.ROUTE_SINGULAR,
      models.FLOOR.ROUTE_SINGULAR,
      models.ROOM.ROUTE_SINGULAR,
      models.ASSET.ROUTE_SINGULAR,
      models.SERVICE_REQUEST.ROUTE_SINGULAR,
    ].join("&");

    Router.configureStates([
      {
        state: "app.workOrders.create",
        config: {
          url: "/create?" + queryParams,
          templateUrl: "app/mobile/modules/work-order/create/create.html",
          controller: "CreateWorkOrderController",
          controllerAs: "vm",
          data: {
            pageTitle: "Create Work Order",
            pushHistory: false,
          },
          params: {
            building: null,
          },
          resolve: {
            building: getBuilding,
            requestId: getRequestId,
            floorId: getFloorId,
            roomId: getRoomId,
            assetId: getAssetId,
          },
        },
      },
    ]);
  }

  /* @ngInject */
  function getBuilding($stateParams, models, account, BuildingService) {
    if (angular.isEmpty($stateParams.building)) {
      return null;
    }

    var building = $stateParams[models.BUILDING.ROUTE_SINGULAR];
    if (!angular.isEmpty(account) && !angular.isEmpty(building)) {
      // ids have been provided so query for the building
      return BuildingService.getById(building).catch(function () {
        return null;
      });
    }

    // don't recognize these params
    return null;
  }

  /* @ngInject */
  function getFloorId($stateParams, account, models) {
    return $stateParams[models.FLOOR.ROUTE_SINGULAR];
  }

  /* @ngInject */
  function getRoomId($stateParams, account, models) {
    return $stateParams[models.ROOM.ROUTE_SINGULAR];
  }

  /* @ngInject */
  function getAssetId($stateParams, account, models) {
    return $stateParams[models.ASSET.ROUTE_SINGULAR];
  }

  /* @ngInject */
  function getRequestId($stateParams, account, models) {
    return $stateParams[models.SERVICE_REQUEST.ROUTE_SINGULAR];
  }
})();
